// extracted by mini-css-extract-plugin
var _1 = "min-width-content__hgqCL";
var _2 = "white-space-no-wrap__Llbat";
export { _1 as "minWidthContent", _2 as "whiteSpaceNoWrap" }
